import {
  Component,
  input,
  output,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatChipOption } from '@angular/material/chips';

@Component({
  selector: 'app-chips-map-buttons',
  imports: [MatChipOption],
  templateUrl: './chips-map-buttons.component.html',
  styleUrl: './chips-map-buttons.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ChipsMapButtonsComponent implements AfterViewInit {
  @ViewChild('chipOption') chipOption!: MatChipOption;

  ariaDescription = input('Botón de acción');
  chipIcon = input('toggle_on');
  chipLabel = input('Chip');
  selectable = input(true);
  isSelected = input(false);
  clicked = output();
  disabled = input(false);

  constructor() {}

  ngAfterViewInit() {
    // El MatChipOption ya está disponible aquí
  }

  // Método para obtener el estado selected
  get selected(): boolean {
    return this.chipOption?.selected ?? false;
  }

  // Método para deseleccionar el chip
  deselect(): void {
    this.chipOption?.deselect();
  }

  // Método para seleccionar el chip
  select(): void {
    this.chipOption?.select();
  }

  onClick() {
    this.clicked.emit();
  }
}
